import { isCheckoutReset } from "../../../../domain/checkout/model/checkoutReset";
import { HttpCheckoutsSaveFunction } from "./httpCheckouts";

const NOT_FOUND = 404;

interface HttpCheckoutsResetFunction extends HttpCheckoutsSaveFunction {}

const httpCheckoutsReset: HttpCheckoutsResetFunction =
  ({ httpPost }) =>
  async ({ aggregateId, domainEvents }) => {
    const checkoutReset = domainEvents.find(isCheckoutReset);

    if (!checkoutReset) {
      return;
    }

    await httpPost<void, void>({
      endpoint: "/reset-checkout",
      body: { checkoutId: aggregateId },
      result: {
        success: () => undefined,
        /* There is nothing to reset when the checkout has no booking left */
        error: (response) => {
          if (response.status === NOT_FOUND) {
            return undefined;
          }

          throw new Error(response.statusText);
        },
      },
    });
  };

export { httpCheckoutsReset };
